export const OPEN_DIALOGUE = 'ipfabric/LeaveDialogue/OPEN_DIALOGUE';
export const CLOSE_DIALOGUE = 'ipfabric/LeaveDialogue/CLOSE_DIALOGUE';
export const LEAVE_DIALOGUE = 'ipfabric/LeaveDialogue/LEAVE_DIALOGUE';
export const SAVE_DIALOGUE = 'ipfabric/LeaveDialogue/SAVE_DIALOGUE';
export const CAN_LEAVE = 'ipfabric/LeaveDialogue/CAN_LEAVE';
export const START_SAVE = 'ipfabric/LeaveDialogue/START_SAVE';
